import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const DirSaleTrendChart = ({ formValues, totalValues }) => {

  let { invPeriodId, periodicity, prodIds } = formValues;

  const {navigateTo} = useNavState();

  const { totalProdIds } = totalValues;

  const rsrc = useRsrc();

  const [data, setData] = useState([]);

  const [finalProdIds, setFinalProdIds] = useState([]);
  const [prodIdsNot, setProdIdsNot] = useState(false);

  useEffect(() => {
    if (!invPeriodId) {
      return;
    }

    let prodIdsNot = true;
    if (totalProdIds.length / 2 < prodIds.length) {
      prodIds = totalProdIds.filter(id => !prodIds.includes(id));
    } else {
      prodIdsNot = false;
    }
    setFinalProdIds(prodIds);
    setProdIdsNot(prodIdsNot);

    const reqParam = {
      periodId: invPeriodId,
      prodIds,
      prodIdsNot
    };

    rsrc.data('sc', 'DIR_SALE_TREND_CHART_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });

  }, [invPeriodId, periodicity, prodIds]);

  const navigateToDirSaleLineList = (dataPoint) => {
    const category = dataPoint.category;
        const rowsReq = {};
        if (periodicity === 'MONTH') {
          const year = category.substring(0, 4);
          const month = category.substring(5);
          const qtr = Math.ceil(parseInt(month) / 3);
          const qtrPeriodCode = year + 'Q' + qtr;
          rowsReq.expr = ExprUtils.whereParams('code', qtrPeriodCode);
        } else if (periodicity === 'QUARTER') {
          rowsReq.expr = ExprUtils.whereParams('code', category);
        }
        rsrc.rows('sc', 'PERIOD', rowsReq).then(periods => {
          const invPeriodIds = periods.map(period => period.id);
          let expr = ExprUtils.whereParams('invPeriodId', invPeriodIds);
    
          if (finalProdIds.length > 0) {
            let prodExpr;
            if (prodIdsNot) {
              prodExpr = ExprUtils.isNotOneOf('prodId', finalProdIds);
            } else {
              prodExpr = ExprUtils.whereParams('prodId', finalProdIds);
            }
            expr = ExprUtils.and(expr, prodExpr);
          }

          if (periodicity === 'MONTH') {
            const month = category.replace('M', '');
            const days = [];
            for (let i = 1; i <= 31; i++) {
              const day = month + i.toString().padStart(2, '0');
              days.push(parseInt(day));
            }
            expr = ExprUtils.and(expr, ExprUtils.whereParams('invDate', days));
          }
    
          const navState = {
            mode: Mode.LIST,
            expr: expr
          };
          navigateTo('/sc/dir-sale-line', navState);
        });
  }

  return (
    <>
        <CartesianChart
          data={data}
          yLabel={'Sold Dollars'}
          xLabel="Invoice Period"
          allowNegative
          onClick={(dataPoint) => navigateToDirSaleLineList(dataPoint)}
        />
    </>

  );
};
